import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {convertKataToRome, convertPipeToBrTag} from '../../utils';
import { getComponents } from '../utilities';
import EstimateLink from "../../components/estimate-link";
import BodyControl from "../../components/body";
import { IS_MOBILE } from "../../constants/environment";
import spacer from './spacer-image.png'
import Accordion from "../../components/accordion";

/**
 *  GradeAndSpecData
 */
class GradeAndSpecData extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    modelName: PropTypes.string,
    bodyTypeModel: PropTypes.string,
    carTypeCode: PropTypes.string,
    gradeId: PropTypes.string,
    gradeCode: PropTypes.string,
    gradeName: PropTypes.string,
    fuelTabName: PropTypes.string,
    specialCar: PropTypes.bool,
    specialCarTabName: PropTypes.string,
    welfareCar: PropTypes.bool,
    welfareCarTabName: PropTypes.string,
    gradeSpecUrl: PropTypes.string,
    supportCar: PropTypes.string,
    description: PropTypes.string,
    mbDescription: PropTypes.string,
    backgroundSrc: PropTypes.string,
    mbBackgroundSrc: PropTypes.string,
    interiorImage: PropTypes.string,
    interiorImage2: PropTypes.string,
    hideEstimationButton: PropTypes.bool,
    defaultDrive: PropTypes.string,
    defaultMission: PropTypes.string,
    displacement: PropTypes.string,
    photoInfo: PropTypes.array,
    freeContentArea: PropTypes.array,
    bodySize: PropTypes.array,
    equipment: PropTypes.array,
    makerOption: PropTypes.array,
    specComparison: PropTypes.array,
    freeContentArea2: PropTypes.array,
    ownerLibraryContainer: PropTypes.array,
    freeContentArea3: PropTypes.array,
    engine: PropTypes.shape({
      name: PropTypes.string,
      drive: PropTypes.string,
      transmission: PropTypes.string,
    }),
    variants: PropTypes.arrayOf(PropTypes.shape({
      engine: PropTypes.string,
      drive: PropTypes.string,
      transmission: PropTypes.string,
      price: PropTypes.number,
      taxInfo: PropTypes.shape({
        acquisitionTaxIsActive: PropTypes.bool,
        acquisitionTaxPrice: PropTypes.number,
        acquisitionTaxRate: PropTypes.number,
        weightTaxPrice: PropTypes.number,
        weightTaxRate: PropTypes.number,
        taxCut: PropTypes.number,
      }),
      kankyowari: PropTypes.bool,
      subsidy: PropTypes.bool,
    })),
    gradeImageSrc: PropTypes.string,
  };

  static defaultProps = {
    containerId: null,
    containerClass: null,
    modelName: null,
    bodyTypeModel: null,
    carTypeCode: null,
    gradeId: null,
    gradeCode: null,
    gradeName: null,
    fuelTabName: null,
    specialCar: null,
    specialCarTabName: null,
    welfareCar: null,
    welfareCarTabName: null,
    gradeSpecUrl: null,
    supportCar: null,
    description: null,
    mbDescription: null,
    backgroundSrc: null,
    mbBackgroundSrc: null,
    interiorImage: null,
    interiorImage2: null,
    hideEstimationButton: null,
    defaultDrive: null,
    defaultMission: null,
    displacement: null,
    photoInfo: null,
    freeContentArea: null,
    bodySize: null,
    equipment: null,
    makerOption: null,
    specComparison: null,
    freeContentArea2: null,
    ownerLibraryContainer: null,
    freeContentArea3: null,
    engine: null,
    variants: null,
    gradeImageSrc: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      isMounted: false,
      background: null,
      variantsWidth: null,
    };
    //this.isCurrent = false;
    this.timeoutId = null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.isCurrent) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const {
      containerId,
      containerClass,
      modelName,
      bodyTypeModel,
      carTypeCode,
      gradeId,
      gradeCode,
      gradeName,
      engine,
      description,
      mbDescription,
      supportCar,
      backgroundSrc,
      mbBackgroundSrc,
      interiorImage,
      interiorImage2,
      hideEstimationButton,
      defaultDrive,
      defaultMission,
      displacement,
      variants,
      gradeImageSrc,
      specialCar,
    } = this.props;

    if (!this.props.isCurrent) return null;

    // エンジン名
    const getEngineName = () => {
      if (engine && engine.name) {
        return engine.name;
      } else {
        return '';
      }
    };
    // const getEngineName = () => {
    //   let engineName = '';
    //   let i, max;
    //   for (i = 0, max = engine.length; i < max; i = i + 1) {
    //     const name = engine[i].name;
    //     if (engineName === '') {
    //       engineName = name;
    //     } else {
    //       engineName = engineName + '/' + name;
    //     }
    //   }
    //   // 重複をとる
    //   engineName = engineName.split('/').filter((x, i, self) => self.indexOf(x) === i).join('/');
    //   return engineName;
    // };

    // 詳細テキスト
    const getPcDescription = () => {
      if (description && description !== '') {
        return description;
      }
      return '';
    };
    const getMbDescription = () => {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };

    // グレード名称
    const getGradeName = () => {
      if (gradeName && gradeName !== '') {
        return gradeName;
      } else if (gradeId && gradeId !== '') {
        return gradeId
      } else {
        return '';
      }
    };

    // PC用PhotoInfoブロック表示
    const renderPcPhotoInfo = () => {
      if (this.state.isMounted === true) {
        if (IS_MOBILE === false) {
          return (
            <div>
              {this.props.photoInfo}
            </div>
          )
        } else {
          return null;
        }
      } else {
        return null;
      }
    };

    // MB用PhotoInfoブロック表示
    const renderMbPhotoInfo = () => {
      if (this.state.isMounted === true) {
        if (IS_MOBILE === true) {
          return (
            <div>
              {this.props.photoInfo}
            </div>
          )
        } else {
          return null;
        }
      } else {
        return null;
      }
    };

    // 100th Anniversary Special Edition > 100周年特別記念車
    const convert100th = (text) => {
      if (text && text !== '') {
        text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
        text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
        text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
        text = text.replace('RF 35th SV', '35周年記念車');
        text = text.replace('35th SV', '35周年記念車');
        text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
        text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
        text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
        text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
        text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
        text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
        text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
        text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
        text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
        text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
        text = text.replace('15 SPORT Plus', '15 SPORT＋');
        text = text.replace('XD SPORT Plus', 'XD SPORT＋');
        return text;
      } else {
        return text;
      }
    };

    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className="GradeAndSpecData">
          <div className="GradeAndSpecData__container"
            style={(this.state.background && this.state.background !== '') ? { backgroundImage: 'url(' + this.state.background + ')' } : null}
          >
            <div className="GradeAndSpecData__container2">
              <div className="GradeAndSpecData__box">
                <div className="GradeAndSpecData__box2">
                  <h3 className="GradeAndSpecData__heading">
                    {(() => {
                      if (specialCar) {
                        return (
                          <span dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(convert100th(gradeId)) }} />
                          // <span dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(gradeId) }} />
                        )
                      } else {
                        return (
                          <span dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(convert100th(getGradeName())) }} />
                          // <span dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(getGradeName()) }} />
                        )
                      }
                    })()}
                  </h3>
                  {/*<h2 className="GradeAndSpecData__heading">{getGradeName()}</h2>*/}
                  {/*<p className="GradeAndSpecData__engine">{getEngineName() + ((displacement && displacement !== '') ? ' ' + displacement + 'cc': '')}</p>*/}
                  <p className="GradeAndSpecData__engine">{getEngineName()}</p>
                  <p className="GradeAndSpecData__description">
                    <span className="GradeAndSpecData__description-pc">
                      <span dangerouslySetInnerHTML={{ __html: getPcDescription() }} />
                      {/*<span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcDescription())}}/>*/}
                    </span>
                    <span className="GradeAndSpecData__description-mb">
                      <span dangerouslySetInnerHTML={{ __html: getMbDescription() }} />
                      {/*<span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbDescription())}}/>*/}
                    </span>
                  </p>
                  <div className="GradeAndSpecData__car-image__wrapper">
                    <img className="GradeAndSpecData__car-image" src={gradeImageSrc} alt="" />
                    {renderMbPhotoInfo()}
                  </div>
                </div>
                {(() => {
                  if ((interiorImage && interiorImage !== '') || (interiorImage2 && interiorImage2 !== '')) {
                    return (
                      <div className="GradeAndSpecData__interior">
                        {(interiorImage && interiorImage !== '') ?
                          <img className="GradeAndSpecData__interior__image" src={interiorImage} /> : null}
                        {(interiorImage2 && interiorImage2 !== '') ?
                          <img className="GradeAndSpecData__interior__image" src={interiorImage2} /> : null}
                      </div>
                    )
                  } else {
                    return (
                      <div className="GradeAndSpecData__interior">
                        <img className="GradeAndSpecData__interior__image" src={spacer} />
                      </div>
                    )
                  }
                })()}
                <div className="GradeAndSpecData__variants" ref="variants">
                  <ul className="GradeAndSpecData__variants__list">
                    <li style={(2 <= this.getVariantInfo().length) ? {width: '50%'} : {width: '100%'}}>
                      {this.getVariantInfo().map((variant, index) => {
                        if (index % 2) {
                          return null;
                        } else {
                          return (
                            <GradeAndSpecDataVariant variantName={variant.name} variantPrice={variant.price} variantTax={variant.tax} variantsWidth={(2 <= this.getVariantInfo().length) ? (this.state.variantsWidth / 2) - 20 : null} key={index} />
                            // <div className="GradeAndSpecData__variants__container" key={index} ref="container">
                            //   <span style={{display: 'inline-block'}} ref="names">
                            //     <span className="GradeAndSpecData__variants__name">{variant.name}</span>
                            //     <span className="GradeAndSpecData__variants__price">{variant.price}<span> (消費税込)</span></span>
                            //   </span>
                            //   {(() => {
                            //     if (variant.tax && 1 <= variant.tax.length) {
                            //       return (
                            //         <span className="GradeAndSpecData__variants__tax test" ref="taxes">
                            //           {variant.tax.map((tax, index2) => {
                            //             return (
                            //               <span className="GradeAndSpecData__variants__tax-item" key={index2}>{tax}</span>
                            //             )
                            //           })}
                            //         </span>
                            //       )
                            //     } else {
                            //       return null;
                            //     }
                            //   })()}
                            // </div>
                          )
                        }
                      })}
                    </li>
                    {(() => {
                      if (2 <= this.getVariantInfo().length) {
                        return (
                          <li>
                            {this.getVariantInfo().map((variant, index) => {
                              if (index % 2) {
                                return (
                                  <GradeAndSpecDataVariant variantName={variant.name} variantPrice={variant.price} variantTax={variant.tax} variantsWidth={(this.state.variantsWidth / 2) - 20} key={index} />
                                  // <div className="GradeAndSpecData__variants__container" key={index}>
                                  //   <span>
                                  //     <span className="GradeAndSpecData__variants__name">{variant.name}</span>
                                  //     <span className="GradeAndSpecData__variants__price">{variant.price}<span> (消費税込)</span></span>
                                  //   </span>
                                  //   {(() => {
                                  //     if (variant.tax && 1 <= variant.tax.length) {
                                  //       return (
                                  //         <span className="GradeAndSpecData__variants__tax">
                                  //           {variant.tax.map((tax, index2) => {
                                  //             return (
                                  //               <span className="GradeAndSpecData__variants__tax-item" key={index2}>{tax}</span>
                                  //             )
                                  //           })}
                                  //         </span>
                                  //       )
                                  //     } else {
                                  //       return null;
                                  //     }
                                  //   })()}
                                  // </div>
                                )
                              } else {
                                return null;
                              }
                            })}
                          </li>
                        )
                      } else {
                        return null;
                      }
                    })()}
                  </ul>
                </div>
                {(hideEstimationButton === false) ?
                  <div className="GradeAndSpecData__estimate">
                    {/*<a className="GradeAndSpecData__estimate__link">見積もりシミュレーション</a>*/}
                    <EstimateLink {...{
                      label: '見積りシミュレーション',
                      targetBlank: false,
                      color: 'Light',
                      buttonStyle: 'Action',
                      linkType: 'Button',
                      carId: bodyTypeModel,
                      carTypeCode: carTypeCode,
                      gradeCode: gradeCode,
                      drive: defaultDrive,
                      mission: defaultMission,
                      engine: variants[0].engine,
                      ecode: null,
                      soptions: null,
                      //direct: 'Result',
                      direct: 'Color-And-Sheet',
                    }} />
                  </div>
                  : null}
              </div>
            </div>
            {renderPcPhotoInfo()}
          </div>
          {(this.props.freeContentArea && 1 <= this.props.freeContentArea.length) ? getComponents(this.props.freeContentArea) : null}
          {(this.props.bodySize && 1 <= this.props.bodySize.length) ? getComponents(this.props.bodySize, {
            modelName: modelName,
            bodyTypeModel: bodyTypeModel,
            carTypeCode: carTypeCode,
            gradeId: gradeId,
          }) : null}
          {(this.props.equipment && 1 <= this.props.equipment.length) ? getComponents(this.props.equipment) : null}
          {(this.props.makerOption && 1 <= this.props.makerOption.length) ? getComponents(this.props.makerOption) : null}
          {/*{(this.props.specComparison && 1 <= this.props.specComparison.length) ? getComponents(this.props.specComparison): null}*/}
          {(this.props.specComparison && 1 <= this.props.specComparison.length) ? getComponents(this.props.specComparison, { isCurrent: this.props.isCurrent }) : null}
          {(this.props.freeContentArea2 && 1 <= this.props.freeContentArea2.length) ? getComponents(this.props.freeContentArea2) : null}
          {(this.props.ownerLibraryContainer && 1 <= this.props.ownerLibraryContainer.length) ? getComponents(this.props.ownerLibraryContainer) : null}
          {(this.props.freeContentArea3 && 1 <= this.props.freeContentArea3.length) ? getComponents(this.props.freeContentArea3) : null}
        </div>
      </Wrapper>
    )
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
      background: (IS_MOBILE === false) ? this.props.backgroundSrc : this.props.mbBackgroundSrc,
    })

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

  };

  componentWillUpdate(nextProps) {

    // グレスペ用アンカーリンクの設定
    if (nextProps.isCurrent !== this.props.isCurrent && nextProps.isCurrent === true) {
      if (window.MZD_SET_ANCHOR_LINK && typeof window.MZD_SET_ANCHOR_LINK == 'function') window.MZD_SET_ANCHOR_LINK();
    }

    // if (nextProps.isCurrent) {
    //   if (this.timeoutId) clearTimeout(this.timeoutId);
    //   this.timeoutId = setTimeout(()=> {
    //     // GTMイベント
    //     BodyControl.setGTMEvent({
    //       selectedgrade: nextProps.gradeName,
    //       selectedbodytype: nextProps.bodyTypeTabName,
    //       event: 'loadgrade',
    //     });
    //     // if (this.props.specComparison && 1 <= this.props.specComparison.length) {
    //     //   // GTMイベント
    //     //   BodyControl.setGTMEvent({
    //     //     trackcartype: variantInfo.drive + '(' + variantInfo.transmission + ')',
    //     //     event: 'SpecComparisonSelect',
    //     //   });
    //     // }
    //   }, 200);
    // }

    //if (nextProps.isCurrent !== this.isCurrent) {
    //this.isCurrent = nextProps.isCurrent;
    if (nextProps.isCurrent) {
      // GTMイベント
      BodyControl.setGTMEvent({
        selectedgrade: nextProps.gradeName || nextProps.gradeId,
        selectedbodytype: nextProps.bodyTypeTabName || nextProps.bodyTypeModel,
        event: 'loadgrade',
      });
    }
    //}

  }

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    })

    window.removeEventListener('resize', this.handleResize);

  }

  // バリエーション情報取得
  getVariantInfo = () => {
    let arr = [];
    this.props.variants.map((variant, index) => {
      let tax = [];
      if (variant.kankyowari === true) {
        tax.push('環境性能割 非課税');
      }
      if (variant.subsidy === true) {
        tax.push('CEV補助金');
        // tax.push('クリーンディーゼル補助金');
      }
      if (variant.taxInfo) {
        if (100 <= variant.taxInfo.weightTaxRate) {
          tax.push('重量税 免税');
        } else if (1 <= variant.taxInfo.weightTaxRate) {
          tax.push('重量税 減税');
        }
      }
      arr.push({
        name: variant.drive + '(' + variant.transmission + ')',
        price: '¥' + variant.price.toLocaleString(),
        tax: tax,
      })
    });
    return arr;
  }

  handleResize = () => {
    this.setState({
      variantsWidth: this.refs.variants.clientWidth,
    });
  };

}

export default GradeAndSpecData;

/**
 *  GradeAndSpecDataVariant
 */
class GradeAndSpecDataVariant extends Component {
  static propTypes = {
    variantName: PropTypes.string,
    variantPrice: PropTypes.string,
    variantTax: PropTypes.arrayOf(PropTypes.string),
    variantsWidth: PropTypes.number,
  };
  static defaultProps = {
    variantName: null,
    variantPrice: null,
    variantTax: null,
    variantsWidth: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      isMounted: false,
    };
    this.intervalId = null;
  }

  componentWillUpdate(nextProps) {
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });

    window.addEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      this.handleResize();
    }, 100);

  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });

    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);

  }

  render() {
    return (
      <div className="GradeAndSpecData__variants__container">
        <span className="GradeAndSpecData__variants__container2" ref="container2">
          <span className="GradeAndSpecData__variants__name">{this.props.variantName}</span>
          <span className="GradeAndSpecData__variants__price">{this.props.variantPrice}<span> (消費税込)</span></span>
        </span>
        {(() => {
          if (this.props.variantTax && 1 <= this.props.variantTax.length) {
            return (
              <span className="GradeAndSpecData__variants__container3" ref="container3">
                <span className="GradeAndSpecData__variants__tax" ref="taxes">
                  {this.props.variantTax.map((tax, index) => {
                    return (
                      <span className="GradeAndSpecData__variants__tax-item" key={index}>{tax}</span>
                    )
                  })}
                </span>
              </span>
            )
          } else {
            return null;
          }
        })()}
      </div>
    )
  }

  handleResize = () => {
    if (this.state.isMounted === false) return;
    if (this.props.variantsWidth === null) return;
    //
    const container2Width = this.refs.container2.clientWidth;
    let taxesWidth = 0;
    if (this.refs.taxes && this.refs.taxes.clientWidth) {
      taxesWidth = this.refs.taxes.clientWidth;
    }
    if (this.refs.container3 && this.refs.container3.style) {
      if (this.props.variantsWidth < container2Width + taxesWidth) {
        this.refs.container3.style.display = 'block';
      } else {
        this.refs.container3.style.display = 'inline-block';
      }
    }
  };

}



// WEBPACK FOOTER //
// ./src/containers/grade-and-spec-data/index.jsx